import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";

import { RFHTextField as RHFTextField, RFHdatePicker, RHFTextEditor } from '../RFH'
import { useResponsive } from "../../hooks/useResponsive";
import { CustomButton } from "../Button/Button";
import { useCreateMilestoneForm } from "./hooks/useCreateMilestoneForm";

export default function AddMilestone({ onClose }) {
  const isMobile = useResponsive("down", "md");
  const { formMethods, handleSubmit, loading, submit } =
    useCreateMilestoneForm({ onClose });

  return (
    <React.Fragment>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(submit)}>
          <Typography className="milestone-lable">
            Milestone Name<span className="star">*</span>
          </Typography>
          <RHFTextField name={"epic_name"} />

          <Typography className="milestone-lable" mt={isMobile ? 1 : 2}>
            Description<span className="star">*</span>
          </Typography>
          <RHFTextEditor name={"description"} minHeight={"135px"} />
          <Stack
            direction="row"
            justifyContent={"space-between"}
            spacing={2.5}
            mt={isMobile ? "40px" : 2}>
            <Box sx={{ width: "100%" }}>
              <Typography className="milestone-lable">Start Date</Typography>
              <RFHdatePicker name="start_date" />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Typography className="milestone-lable">Target Date</Typography>
              <RFHdatePicker name={"target_release_date"} />
            </Box>
          </Stack>

          <Box className="button-container d-flex justify-content-end" mt={3}>
     
            <CustomButton
              type="submit"
              variant="contained"
              className="create-button"
              disabled={loading}
            >
              Create
            </CustomButton>
            <CustomButton
              type="button"
              variant="outlined"
              className="cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </CustomButton>
          </Box>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}
